import React, { useEffect } from "react";
import Routers from "./Route";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "./_helper/ErrorBoundary";
import { setupGlobalErrorHandlers } from "./_helper/errorHandler";
import "./_helper/ErrorBoundary.scss";

const App = () => {
  useEffect(() => {
    setupGlobalErrorHandlers();
  }, []);

  return (
    <div className="App">
      <ErrorBoundary componentName="App">
        <CustomizerProvider>
          <AnimationThemeProvider>
            <Toaster position="top-right" />
            <Routers />
          </AnimationThemeProvider>
        </CustomizerProvider>
      </ErrorBoundary>
    </div>
  );
};

export default App;
